__turbopack_context__.v({
  "my_list_show": "MyListShowPoster-module-scss-module__HCioPa__my_list_show",
  "my_list_show_kabob_menu": "MyListShowPoster-module-scss-module__HCioPa__my_list_show_kabob_menu",
  "my_list_show_link": "MyListShowPoster-module-scss-module__HCioPa__my_list_show_link",
  "my_list_show_remove_button": "MyListShowPoster-module-scss-module__HCioPa__my_list_show_remove_button",
});
